module.exports = function() {
  return new Worker(__webpack_public_path__ + "787e5d5a713939183bc1.worker.js");
};